/** ConeTwistJoint3D registration: the parser. Property knowledge for linting lives in linterParser.ts. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseConeTwistJoint3D } from './parser';
const coneTwistJoint3DRegistration = {
    typeName: 'ConeTwistJoint3D',
    parser: parseConeTwistJoint3D,
};
nodeRegistry.register(coneTwistJoint3DRegistration);
//# sourceMappingURL=index.js.map